class MegaMenu {
  constructor() {
    console.log('MegaMenu constructor called');
    this.triggers = document.querySelectorAll('[data-mega-menu-trigger]');
    this.menus = document.querySelectorAll('[data-mega-menu]');
    console.log('Found triggers:', this.triggers.length, 'menus:', this.menus.length);
    this.triggerMethod = document.querySelector('[data-mega-menu-method]')?.dataset.megaMenuMethod || 'hover';
    this.activeMenu = null;

    this.init();
  }

  init() {
    if (this.triggerMethod === 'hover') {
      this.initHover();
    } else {
      this.initClick();
    }

    this.initKeyboard();
    this.initClickOutside();
  }

  initHover() {
    this.triggers.forEach(trigger => {
      const menuId = trigger.dataset.megaMenuTrigger;
      const menu = document.querySelector(`[data-mega-menu="${menuId}"]`);

      if (!menu) return;

      const menuItem = trigger.closest('.header__menu-item');

      menuItem.addEventListener('mouseenter', () => {
        this.openMenu(menu, trigger);
      });

      menuItem.addEventListener('mouseleave', () => {
        this.closeMenu(menu, trigger);
      });
    });
  }

  initClick() {
    this.triggers.forEach(trigger => {
      const menuId = trigger.dataset.megaMenuTrigger;
      const menu = document.querySelector(`[data-mega-menu="${menuId}"]`);

      if (!menu) return;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.activeMenu === menu) {
          this.closeMenu(menu, trigger);
        } else {
          this.closeAllMenus();
          this.openMenu(menu, trigger);
        }
      });
    });
  }

  initKeyboard() {
    this.triggers.forEach(trigger => {
      trigger.addEventListener('keydown', (e) => {
        const menuId = trigger.dataset.megaMenuTrigger;
        const menu = document.querySelector(`[data-mega-menu="${menuId}"]`);

        if (!menu) return;

        // Enter or Space to toggle
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (this.activeMenu === menu) {
            this.closeMenu(menu, trigger);
          } else {
            this.closeAllMenus();
            this.openMenu(menu, trigger);
          }
        }

        // Escape to close
        if (e.key === 'Escape') {
          this.closeMenu(menu, trigger);
          trigger.focus();
        }
      });
    });
  }

  initClickOutside() {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.header__menu-item')) {
        this.closeAllMenus();
      }
    });
  }

  openMenu(menu, trigger) {
    menu.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.closest('.header__menu-item').classList.add('is-active');
    this.activeMenu = menu;
  }

  closeMenu(menu, trigger) {
    menu.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.closest('.header__menu-item').classList.remove('is-active');
    if (this.activeMenu === menu) {
      this.activeMenu = null;
    }
  }

  closeAllMenus() {
    this.menus.forEach(menu => {
      const menuId = menu.dataset.megaMenu;
      const trigger = document.querySelector(`[data-mega-menu-trigger="${menuId}"]`);
      if (trigger) {
        this.closeMenu(menu, trigger);
      }
    });
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MegaMenu();
  });
} else {
  new MegaMenu();
}